import { MapPin, Phone, Mail } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const locations = [{
  id: "campus-principal",
  name: "Centro de Estudios Cosmos",
  address: "Plaza de la Constitución s/n, Palencia, España",
  phone: "610 74 30 69",
  email: "centrocosmos@gmail.com"
}];
export default function OfficeLocations() {
  return <section data-section-id="222658" id="nuestra-ubicación" className="w-full bg-background text-foreground relative">
      {}
      <div className="w-full h-[500px] md:h-[600px] relative bg-muted">
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/grayscale_city_map_indigo_marker.png)] bg-cover bg-center opacity-90" aria-label="Mapa de ubicación de la academia LUMEN con marcador índigo" role="img" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/10 to-transparent !bg-[url(https://centrocosmos.es/wp-content/uploads/2026/05/Captura-de-pantalla-plano-academia.png)]" />
      </div>

      {}
      <div className="max-w-6xl mx-auto px-6 relative z-10 -mt-32 pb-16">
        <div className="mb-8 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4 tracking-tight">
            Nuestra Ubicación
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl leading-relaxed">Encuéntranos en Plaza de la Constitución. Palencia. Un espacio diseñado para inspirar el aprendizaje y la creatividad.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {locations.map((location, i) => <div data-index={i} key={location.id}>
              <Card className="rounded-lg border-border bg-card/95 backdrop-blur-md shadow-xl h-full flex flex-col transition-shadow hover:shadow-2xl">
                <CardHeader className="pb-4 border-b border-border/50">
                  <CardTitle className="text-2xl font-default flex items-center gap-2 text-foreground">
                    <MapPin className="w-6 h-6 text-primary" />
                    {location.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-6 flex-grow flex flex-col gap-4">
                  <div className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/5 p-2 rounded-md">
                      <MapPin className="w-4 h-4 text-primary" />
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground font-mono uppercase tracking-widest mb-1">Dirección</p>
                      <p className="text-foreground font-medium font-sans">{location.address}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/5 p-2 rounded-md">
                      <Phone className="w-4 h-4 text-primary" />
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground font-mono uppercase tracking-widest mb-1">Teléfono</p>
                      <p className="text-foreground font-medium font-sans">{location.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/5 p-2 rounded-md">
                      <Mail className="w-4 h-4 text-primary" />
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground font-mono uppercase tracking-widest mb-1">Email</p>
                      <p className="text-foreground font-medium font-sans">{location.email}</p>
                    </div>
                  </div>

                  <div className="mt-auto pt-6">
                    <Button variant="outline" className="w-full rounded-md border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 font-default font-semibold">
                      Cómo llegar
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}